import currency from 'currency.js'
export const CurrencyFormat = (value: number | string, precision:number = 0) =>
    currency(value, {
        symbol: '',
        separator: ' ',
        precision: precision,
    }).format();